<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'dealers.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <Grid name="lastSalesGrid" v-bind:url="url" v-bind:columns="columns" :pageable='false' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/LocalGrid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'UsersGrid',
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'import_last_sale': {
          type: 'date'
        },
        'campaign_last_process': {
          type: 'date'
        },
        'campaign_last_sale': {
          type: 'date'
        }
      },
      url: 'dealers/lastsales',
      columns: [{
        field: 'dealer.data.name',
        title: 'Nome'
      }, {
        field: 'campaign_last_sale',
        title: 'Última venda processada',
        format: '{0:dd/MM/yyyy}',
        type: 'date',
        width: '220px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDatePicker({
              format: 'dd/MM/yyyy'
            })
          }
        }
      }, {
        field: 'import_last_sale',
        title: 'Última venda importada',
        format: '{0:dd/MM/yyyy}',
        type: 'date',
        width: '220px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDatePicker({
              format: 'dd/MM/yyyy'
            })
          }
        }
      }, {
        field: 'campaign_last_process',
        title: 'Último processamento',
        format: '{0:dd/MM/yyyy  HH:mm}',
        type: 'date',
        width: '220px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy  HH:mm'
            })
          }
        }
      }]
    }
  }
}
</script>
